import React from 'react';

import './_test-execution-details.scss';

type Props = {
  shouldAddDetailsPrefix: boolean;
  label: string;
  additionalClassName?: string;
};

function TestExecutionTableTestCaseHeader({
  shouldAddDetailsPrefix,
  label,
  additionalClassName = '',
}: Props): JSX.Element {
  const testCaseClassNameColumn =
    'column-header-test-case' + (shouldAddDetailsPrefix ? '-details' : '');

  return (
    <div
      className={
        'test-execution-steps-header column-header ' + testCaseClassNameColumn
      }
    >
      <h5 className={'test-execution-header-label ' + additionalClassName}>
        {label}
      </h5>
    </div>
  );
}

export default TestExecutionTableTestCaseHeader;
